<template>
  <v-card height="100%">
    <v-card-item>
      <v-card-title>
        <sf-heading>{{ $t('paymentMethod') + (readOnly ? '' : ' *') }}</sf-heading>
      </v-card-title>
    </v-card-item>
    <v-card-text>
      <v-select
        v-model="model"
        class="mt-1"
        :rules="[requiredRule]"
        density="compact"
        :items="getMobexPaymentMethods()"
        :placeholder="$t('pleaseSelect')"
        item-title="translation"
        item-value="title"
        variant="underlined"
        autocomplete="off"
        :disabled="readOnly"
      />
      <div v-if="model && model == 'CREDIT'" class="d-flex flex-row align-start">
        <v-icon class="mr-1" :icon="mdiInformationOutline" />
        <sf-secondary-text>{{ $t('mobex360Info') }}</sf-secondary-text>
      </div>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import SfHeading from '@/components/text/SfHeading.vue'
import SfSecondaryText from '@/components/text/SfSecondaryText.vue'
import { getMobexPaymentMethods } from '@/modules/user/helpers'
import { requiredRule } from '@/rules'
import { mdiInformationOutline } from '@mdi/js'

const model = defineModel<string>()
defineProps({
  readOnly: {
    type: Boolean,
    default: false
  }
})
</script>
